import * as vp from 'vopay';

import { FunctionComponent, useContext, useMemo } from 'react';
import TransactionsContext from './TransactionsContext';

import { DialogueHandler, TransactionDialogueHandlers } from '../types';

const { ConfirmationDialogue } = vp;

type TransactionsDialogueProps = {
  handleDialogue: DialogueHandler<TransactionDialogueHandlers>;
};

type FC = FunctionComponent<TransactionsDialogueProps>;

const TransactionsDialogue: FC = ({ handleDialogue }: TransactionsDialogueProps) => {
  const {
    showTransactionsSearchErrorAlert,
    showTransactionsRefundErrorAlert,
    showTransactionsRefundSuccessAlert,
    transactionsSearchError,
    transactionRefundError,
  } = useContext(TransactionsContext);

  return useMemo(
    () => (
      <div>
        {/* Transaction Search Error */}

        <ConfirmationDialogue
          isVisible={showTransactionsSearchErrorAlert}
          status="error"
          title="Error while trying to fetch transactions."
          subTitle={`Please address the following issue(s): ${transactionsSearchError}`}
          confirm={{
            label: 'Back to Transactions',
            action: () => handleDialogue({ type: 'search', state: 'fail', hasNavigation: false }),
          }}
        />

        {/* Transaction Refund Error */}

        <ConfirmationDialogue
          isVisible={showTransactionsRefundErrorAlert}
          title="Error! The refund was not successful."
          status="error"
          subTitle={`Transaction ${transactionRefundError}`}
          confirm={{
            label: 'Back to Accounts',
            action: () => handleDialogue({ type: 'refund', state: 'fail', hasNavigation: true }),
          }}
          cancel={{
            label: 'Stay Here',
            action: () => handleDialogue({ type: 'refund', state: 'fail', hasNavigation: false }),
          }}
        />

        {/* Transaction Refund Success */}

        <ConfirmationDialogue
          isVisible={showTransactionsRefundSuccessAlert}
          title="Success! The transaction has been refunded."
          status="success"
          subTitle="Navigate back to accounts or refresh your transactions."
          confirm={{
            label: 'Back to Accounts',
            action: () => handleDialogue({ type: 'refund', state: 'success', hasNavigation: true }),
          }}
          cancel={{
            label: 'Stay Here',
            action: () => handleDialogue({ type: 'refund', state: 'success', action: 'refresh', hasNavigation: false }),
          }}
        />
      </div>
    ),
    [showTransactionsSearchErrorAlert, showTransactionsRefundErrorAlert, showTransactionsRefundSuccessAlert],
  );
};

export default TransactionsDialogue;
